<script setup>
import {ref, computed} from 'vue'
import {useViewStore} from '@/stores/view'
import Button from '@/common/Button.vue'

const props = defineProps({
    viewId: String
})

// Dynamic View Store
const viewStore = useViewStore(props.viewId)

// Local reactive state
const name = ref('')

// Template refs
const form = ref(null)
const input = ref(null)

// Computed properties
const filters = computed(() => {
    return viewStore.filters || null
})

const show = computed(() => {
    if (!filters.value) return false
    return Object.values(filters.value).length > 0
})

const savedFilters = computed(() => {
    return viewStore.savedFilters || []
})

const savedFilterNames = computed(() => {
    return savedFilters.value.map(o => o.name)
})

// Methods
const onSubmit = () => {
    if (!name.value.trim()) return

    viewStore.saveFilters(name.value)
    name.value = ''
}
</script>

<template>
    <form ref="form" v-if="show" @submit.prevent="onSubmit" class="input-group d-inline-flex w-auto">
        <!-- Swapped autocomplete to "off" to adhere to proper browser standards -->
        <input ref="input" v-model="name" list="savedFilterNames" autocomplete="off" placeholder="Name" required
               class="form-control form-control-sm"/>

        <datalist v-if="savedFilterNames.length" id="savedFilterNames">
            <!-- Bound the element loop :key directly to the name string to ensure clear rendering isolation -->
            <option v-for="savedName in savedFilterNames" :value="savedName" :key="savedName"></option>
        </datalist>

        <Button type="submit" class="btn-sm border border-start-0 focus-ring">Save</Button>
    </form>
</template>